import React from 'react';
import { formatCurrency } from '@/utils/currency';

type DonationAmountProps = {
  amount: number;
  donationId: string;
};

export default function DonationAmount({
  amount,
  donationId,
}: DonationAmountProps) {
  return (
    <span data-testid={`entity-details-summary-amount-${donationId}`}>
      {formatCurrency(amount, true)}
    </span>
  );
}
